import { NodeViewMode } from '@/enums/node-view-mode.enum';
import { ViewModeNavigationToolbar } from './ViewModeNavigationToolbar';
import { ActionButtonsToolbar } from './ActionButtonsToolbar';
import { AssetMetadataToolbar } from './AssetMetadataToolbar';
import type { NodeCarouselV2Props } from '@/components/Common/ImageList/NodeCarousel';
import type { UploadedAsset } from '@/types/api/assets';
import type { FileKind } from '@/designer/designer';
import type { FileSortOrder } from '@/types/node';
import type { ReactNode } from 'react';

interface NodeCarouselProps {
  steps?: NodeCarouselV2Props['steps'];
  selected?: NodeCarouselV2Props['selected'];
  handleBack?: NodeCarouselV2Props['handleBack'];
  handleNext?: NodeCarouselV2Props['handleNext'];
}
export interface FilesViewOverlayProps extends NodeCarouselProps {
  isAllBatchesHaveSingleGeneration?: boolean;
  // All / Batch view mode props
  filesNavigationComponent?: ReactNode;
  showExpandToGalleryButton?: boolean;
  showDownloadAllButton?: boolean;
  onDownloadAll?: () => void;
  onOpenGallery?: () => void;
  viewMode?: NodeViewMode; // displayed view mode - can be different from selectedViewMode when there is only a single item
  selectedViewMode?: NodeViewMode; // user selected view mode ()
  setViewMode?: (viewMode: NodeViewMode) => void;
  // Single asset view mode props (from AssetOverlay)
  asset?: UploadedAsset | FileKind;
  setIs3DLocked?: (is3DLocked: boolean) => void;
  is3DLocked?: boolean;
  isModelNode?: boolean;
  bottomToolbarOffset?: number;
  sortOrder?: FileSortOrder;
  onSortOrderChange?: (sortOrder: FileSortOrder) => void;
}

export const FilesViewOverlay = ({
  isAllBatchesHaveSingleGeneration,
  // All / Batch view mode props
  filesNavigationComponent,
  showDownloadAllButton = true,
  onDownloadAll,
  onOpenGallery,
  showExpandToGalleryButton = false,
  viewMode,
  selectedViewMode,
  setViewMode,
  // Single asset view mode props
  asset,
  setIs3DLocked,
  is3DLocked,
  isModelNode = false,
  bottomToolbarOffset,
  // Sort props
  sortOrder,
  onSortOrderChange,
  // NodeCarousel props
  ...nodeCarouselProps
}: FilesViewOverlayProps) => {
  const isSingleAssetMode = viewMode === NodeViewMode.Single;
  const isBatchViewMode = viewMode === NodeViewMode.Batch;
  return (
    <>
      <ViewModeNavigationToolbar
        isSingleAssetMode={isSingleAssetMode}
        selectedViewMode={selectedViewMode}
        setViewMode={setViewMode}
        isModelNode={isModelNode}
        nodeCarouselProps={nodeCarouselProps}
        filesNavigationComponent={filesNavigationComponent}
        isAllBatchesHaveSingleGeneration={isAllBatchesHaveSingleGeneration}
      />

      <ActionButtonsToolbar
        isSingleAssetMode={isSingleAssetMode}
        isBatchViewMode={isBatchViewMode}
        asset={asset}
        showDownloadAllButton={showDownloadAllButton}
        showExpandToGalleryButton={showExpandToGalleryButton}
        onOpenGallery={onOpenGallery}
        onDownloadAll={onDownloadAll}
        sortOrder={sortOrder}
        onSortOrderChange={onSortOrderChange}
      />

      <AssetMetadataToolbar
        bottomOffset={bottomToolbarOffset}
        isSingleAssetMode={isSingleAssetMode}
        setIs3DLocked={setIs3DLocked}
        is3DLocked={is3DLocked}
        asset={asset}
      />
    </>
  );
};
